const API_URL =
    process.env.REACT_APP_API_URL ??
    "https://carron-lodge.fusionweb.cloud/api";

export const Constants = {
    API_URL,
    REVERB_HOST:
        process.env.REACT_APP_REVERB_HOST ??
        "ws.carron-lodge.fusionweb.cloud",
    REVERB_PORT: parseInt(
        process.env.REACT_APP_REVERB_PORT ?? "80",
        10
    ),
    REVERB_APP_ID: process.env.REACT_APP_REVERB_APP_ID ?? "",
    REVERB_APP_KEY:
        process.env.REACT_APP_REVERB_APP_KEY ?? "",
    REVERB_APP_SECRET:
        process.env.REACT_APP_REVERB_APP_SECRET ?? "",
};
